import '@mdi/font/css/materialdesignicons.css';
// import 'material-design-icons-iconfont/dist/material-design-icons.css';
// import '@fortawesome/fontawesome-free/css/all.css';
import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import pt from 'vuetify/src/locale/pt';

Vue.use(Vuetify);

const opts = {
  lang: {
    locales: { pt },
    current: 'pt',
  },
  // icons: {
  //   iconfont: 'mdi'
  // },
  theme: {
    themes: {
      light: {
        primary: '#3c3f41',
        secondary: '#F2F2F2',
      },
    },
  },
};

export default new Vuetify(opts);
